import * as React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import menuDotsHorizontal from '../assets/images/menu-dots-horizontal.svg';
import confirmEventsIcon from '../assets/images/properties-freeslot-icon.svg';
import clockGreen from '../assets/images/clock-green.svg';
import clockRed from '../assets/images/clock-red.svg';
import clockOrange from '../assets/images/clock-orange.svg';
import freeSlotEventsIcon from '../assets/images/free-slot-events-icon.svg';
import toBeConfirmedEventsIcon from '../assets/images/to-be-confirm-events-card-icon.svg';
import nextIcon from '../assets/images/right-arrow-black.svg';
import prevDisabledBtn from '../assets/images/prev-btn-disabled.svg';
import freeSlotAlertIcon from '../assets/images/freeSlot-event-card-alert.svg';
import toBeConfirmedEventAlertIcon from '../assets/images/toBeConfirmed-event-card-alert.svg';
import { variables } from "../Variables";
import { setShowWaitingAndEventsModal } from "../features/ShowWaitingAndEventsModal";
import closeIcon from '../assets/images/cross-close.svg';

const buildConfirmUrl = (event, language) => {
    const base = `${variables.AgentSiteURL}eventhandler`;
    const contactId       = event.contactId        || "";
    const eventId         = event.eventId          || "";
    const clientId        = event.clientId         || "";
    const officeId        = event.officeId         || "";
    const contactFirstName = event.contactFirstName || "";
    const contactName     = event.contactName      || "";
    const contactLanguage = language || event.contactLanguage  || "en-GB";
    const estateId        = event.estateId         || "";
    const agentId         = event.agentId          || "";
    const internalEventId = event.internalEventId  || "";
    return `${base}/${contactId}/${eventId}/${clientId}/${officeId}/${contactFirstName}/${contactName}/${contactLanguage}/${estateId}/${agentId}/${internalEventId}`;
};

// Route: /eventdenialhandler/:contactId?/:eventId?/:clientId?/:officeId?/:contactName?
//        /:contactLanguage?/:propertyId?/:agentId?/:internalEventId?
const buildRefuseUrl = (event, language) => {
    const base = `${variables.AgentSiteURL}eventdenialhandler`;
    const contactId       = event.contactId        || "";
    const eventId         = event.eventId          || "";
    const clientId        = event.clientId         || "";
    const officeId        = event.officeId         || "";
    const contactName     = event.contactName      || "";
    const contactLanguage = language || event.contactLanguage  || "en-GB";
    const estateId        = event.estateId         || "";
    const agentId         = event.agentId          || "";
    const internalEventId = event.internalEventId || "";
    return `${base}/${contactId}/${eventId}/${clientId}/${officeId}/${contactName}/${contactLanguage}/${estateId}/${agentId}/${internalEventId}`;
};

export const PropertyEventsCard = ({ specficEstateEvents, estateData }) => {

    // Track which event is currently displayed per group (for next/prev navigation)
    const [indexMap, setIndexMap] = useState({});
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxSelectedLanguage = useSelector(state => state.selectedLanguageTranslations.selectedLanguage);

    const dispatch = useDispatch();

    // Modal state
    const [modalShow, setModalShow]         = useState(false);
    const [modalType, setModalType]         = useState("");   // "refuse" | "confirm" | "detail"
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [iframeLoading, setIframeLoading] = useState(true);

    const openModal = (type, event) => {
        setModalType(type);
        setSelectedEvent(event);
        setIframeLoading(true);
        setModalShow(true);
    };

    const closeModal = () => {
        setModalShow(false);
        setModalType("");
        setSelectedEvent(null);
        setIframeLoading(true);
    };

    // Navigate prev/next within a group
    const navigate = (groupName, events, direction) => {
        setIndexMap(prev => {
            const current = prev[groupName] || 0;
            const next = current + direction;
            if (next < 0 || next >= events.length) return prev;
            return { ...prev, [groupName]: next };
        });
    };

    if (!specficEstateEvents || specficEstateEvents.length === 0) return null;

    // open waiting and events record modal
    const handleOpenWaitingListAndEventsRecordModal = () => {
        dispatch(setShowWaitingAndEventsModal(true));
    }

    const bookingSiteNavigate = (estateId) => {
        let url = `${variables.Booking_URL}${estateId}`;
        window.open(url, "_blank");
    }

    return (
        <>
            <div className="propterty-events-card-container d-flex justify-content-between">
                {specficEstateEvents.map((item) => {
                    const [groupName, events] = Object.entries(item)[0];
                    const currentIndex = indexMap[groupName] || 0;
                    const event = events[currentIndex];

                    const cardIcon          = groupName === "confirmedEvents" ? confirmEventsIcon    : groupName === "freeSlotEvents" ? freeSlotEventsIcon    : toBeConfirmedEventsIcon;
                    const clockIcon         = groupName === "confirmedEvents" ? clockGreen           : groupName === "freeSlotEvents" ? clockRed              : clockOrange;
                    const eventSpecificColor = groupName === "confirmedEvents" ? "dark-green"        : groupName === "freeSlotEvents" ? "dark-red"            : "dark-orange";
                    const border            = groupName === "confirmedEvents" ? "border-light-green" : groupName === "freeSlotEvents" ? "border-light-red"    : "border-light-orange";
                    const cardContainer     = groupName === "confirmedEvents" ? "confirm-events-card": groupName === "freeSlotEvents" ? "freeSlot-events-card": "toBeconfirm-events-card";

                    const hasPrev = currentIndex > 0;
                    const hasNext = currentIndex < events.length - 1;

                    const freeSlotPadding = groupName === "freeSlotEvents" && event.waitingListCount > 0 && event.eventCount == 0;

                    return (
                        <React.Fragment key={groupName}>
                            <div className={`${cardContainer} rounded`}>

                                {/* Dots menu */}
                                {/*<div className="text-end">*/}
                                {/*    <img src={menuDotsHorizontal} alt="menu" />*/}
                                {/*</div>*/}

                                <div className="d-flex justify-content-between align-items-center">
                                    {/* Left: count + title */}
                                    <div>
                                        <div className="d-flex mb-2">
                                            <img src={cardIcon} alt="icon" />
                                            <h5 className={`${eventSpecificColor} ms-2`}>{event.eventCount}</h5>
                                        </div>
                                        <h6 className="mb-0 events-card-title">{event.eventTitle}</h6>
                                    </div>

                                    {/* Right: detail box */}
                                    <div className={`events-card-detail-container ${border} bg-white ${freeSlotPadding ? "p-0" : "p-2"} rounded`}>
                                        <h5 className={`mb-0 events-card-sub-title ${eventSpecificColor} ${freeSlotPadding ? "px-2" : "p-0"}`}>
                                            {event.eventSubTitle}
                                        </h5>
                                        <div className={`d-flex justify-content-between align-items-center ${freeSlotPadding ? "px-2" : "p-0"}`}>
                                            <div>
                                                {/* Date row */}
                                                <div className="properties-event-dateTime-container d-flex align-items-center mb-1">
                                                    <img src={clockIcon} alt="clock" />
                                                    <p className="mb-0 mx-1 events-card-content">
                                                        {groupName === "freeSlotEvents" ? "Date" : event.eventDateTime || "—"}
                                                    </p>
                                                    <p className="mb-0 events-card-content mt-0">
                                                        {event.eventDurationTime || "—"}
                                                    </p>
                                                </div>

                                                {/* Agent / Contact / Time row */}
                                                <div className="properties-event-dateTime-container d-flex align-items-center">
                                                    <img src={clockIcon} alt="clock" />
                                                    <p className="mb-0 mx-1 events-card-content">
                                                        {groupName === "confirmedEvents" ? "Agent"
                                                            : groupName === "freeSlotEvents" ? "Heure"
                                                            : "Contact"}
                                                    </p>
                                                    <p className="mb-0 events-card-content mt-0">
                                                        {groupName === "confirmedEvents"
                                                            ? event.agentName || "—"
                                                            : groupName === "freeSlotEvents"
                                                                ? event.eventDurationTime || "—"
                                                                : `${event.contactFirstName || ""} ${event.contactName || ""}`.trim() || "—"
                                                        }
                                                    </p>
                                                </div>

                                                {/* Refuse / Confirm buttons — TBC only */}
                                                {groupName === "toBeConfirmedEvents" && (
                                                    <div className="d-flex justify-content-between mt-2">
                                                        <div>
                                                            <button
                                                                className="property-events-card-btn bg-dark-red text-white fw-bold me-2"
                                                                onClick={event.eventCount > 0 ? () => openModal("refuse", event) : undefined}
                                                                style={{ cursor: event.eventCount > 0 ? 'pointer' : 'not-allowed', opacity: event.eventCount > 0 ? 1 : 0.5 }}
                                                            >
                                                                {reduxLanguageTranslations ? reduxLanguageTranslations["refuse"] : "Refuser"}
                                                            </button>
                                                            <button
                                                                className="property-events-card-btn bg-dark-green text-white fw-bold"
                                                                onClick={event.eventCount > 0 ? () => openModal("confirm", event) : undefined}
                                                                style={{ cursor: event.eventCount > 0 ? 'pointer' : 'not-allowed', opacity: event.eventCount > 0 ? 1 : 0.5 }}
                                                            >
                                                                {reduxLanguageTranslations ? reduxLanguageTranslations["newEventModalConfirmBtn"] : "Confirmer"}
                                                            </button>
                                                        </div>
                                                        {/* Prev / Next navigation */}
                                                        <div>
                                                            <button
                                                                className="next-prev-events-card-btn me-3"
                                                                onClick={() => navigate(groupName, events, -1)}
                                                                disabled={!hasPrev}
                                                            >
                                                                <img src={prevDisabledBtn} alt="prev"
                                                                    style={{ opacity: hasPrev ? 1 : 0.3 }} />
                                                            </button>
                                                            <button
                                                                className="next-prev-events-card-btn"
                                                                onClick={() => navigate(groupName, events, 1)}
                                                                disabled={!hasNext}
                                                            >
                                                                <img src={nextIcon} alt="next"
                                                                    style={{ opacity: hasNext ? 1 : 0.3 }} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Action button */}
                                            {/*<div className="ms-2">*/}
                                            {/*    {groupName === "confirmedEvents" ? (*/}
                                            {/*        <button*/}
                                            {/*            className="property-events-card-btn bg-dark-green text-white fw-bold"*/}
                                            {/*            onClick={event.eventCount > 0 ? () => openModal("detail", event) : undefined}*/}
                                            {/*            style={{ cursor: event.eventCount > 0 ? 'pointer' : 'not-allowed', opacity: event.eventCount > 0 ? 1 : 0.5 }}*/}
                                            {/*        >*/}
                                            {/*            {reduxLanguageTranslations ? reduxLanguageTranslations["details"] : "Détails"}*/}
                                            {/*        </button>*/}
                                            {/*    ) : groupName === "freeSlotEvents" ? (*/}
                                            {/*            <button onClick={() => bookingSiteNavigate(event.estateId)} className={`${event.eventCount == 0 ? "d-none" : "property-events-card-btn bg-dark-red text-white fw-bold"}`}>*/}
                                            {/*                {reduxLanguageTranslations ? reduxLanguageTranslations["bookThisSlot"] : "Booker ce crénaux"}*/}
                                            {/*            </button>*/}
                                            {/*    ) : null}*/}
                                            {/*</div>*/}

                                            {/* Action button */}
                                            <div className="ms-2">
                                                {groupName === "confirmedEvents" ? (
                                                    <div className="d-flex flex-column align-items-end gap-2">
                                                        <button
                                                            className="property-events-card-btn bg-dark-green text-white fw-bold"
                                                            onClick={event.eventCount > 0 ? () => openModal("detail", event) : undefined}
                                                            style={{ cursor: event.eventCount > 0 ? 'pointer' : 'not-allowed', opacity: event.eventCount > 0 ? 1 : 0.5 }}
                                                        >
                                                            {reduxLanguageTranslations ? reduxLanguageTranslations["details"] : "Détails"}
                                                        </button>
                                                        {/* Prev / Next navigation — confirmed */}
                                                        <div>
                                                            <button
                                                                className="next-prev-events-card-btn me-3"
                                                                onClick={() => navigate(groupName, events, -1)}
                                                                disabled={!hasPrev || events.length <= 1}
                                                            >
                                                                <img src={prevDisabledBtn} alt="prev"
                                                                    style={{ opacity: (hasPrev && events.length > 1) ? 1 : 0.3 }} />
                                                            </button>
                                                            <button
                                                                className="next-prev-events-card-btn"
                                                                onClick={() => navigate(groupName, events, 1)}
                                                                disabled={!hasNext || events.length <= 1}
                                                            >
                                                                <img src={nextIcon} alt="next"
                                                                    style={{ opacity: (hasNext && events.length > 1) ? 1 : 0.3 }} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : groupName === "freeSlotEvents" ? (
                                                    <div className="d-flex flex-column align-items-end gap-2">
                                                        <button onClick={() => bookingSiteNavigate(event.estateId)} className={`${event.eventCount == 0 ? "d-none" : "property-events-card-btn bg-dark-red text-white fw-bold"}`}>
                                                            {reduxLanguageTranslations ? reduxLanguageTranslations["bookThisSlot"] : "Booker ce crénaux"}
                                                        </button>
                                                        {/* Prev / Next navigation — free slots */}
                                                        <div>
                                                            <button
                                                                className="next-prev-events-card-btn me-3"
                                                                onClick={() => navigate(groupName, events, -1)}
                                                                disabled={!hasPrev || events.length <= 1}
                                                            >
                                                                <img src={prevDisabledBtn} alt="prev"
                                                                    style={{ opacity: (hasPrev && events.length > 1) ? 1 : 0.3 }} />
                                                            </button>
                                                            <button
                                                                className="next-prev-events-card-btn"
                                                                onClick={() => navigate(groupName, events, 1)}
                                                                disabled={!hasNext || events.length <= 1}
                                                            >
                                                                <img src={nextIcon} alt="next"
                                                                    style={{ opacity: (hasNext && events.length > 1) ? 1 : 0.3 }} />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        <button onClick={handleOpenWaitingListAndEventsRecordModal} className={`${groupName === "freeSlotEvents" && event.waitingListCount > 0 ? "waitingList-estate-btn fw-bold mt-2" : "d-none"}`}>
                                            {reduxLanguageTranslations ? reduxLanguageTranslations["waitingListHeading"] : "Waiting List"} : {event.waitingListCount}
                                        </button>
                                    </div>
                                </div>

                                {/* Alert icon */}
                                <div className="events-card-alert-icon">
                                    {groupName === "freeSlotEvents" && event.eventCount == 0 ? (
                                        <img src={freeSlotAlertIcon} alt="alert" />
                                    ) : groupName === "toBeConfirmedEvents" && 0 < event.eventCount ? (
                                        <img src={toBeConfirmedEventAlertIcon} alt="alert" />
                                    ) : null}
                                </div>

                            </div>
                        </React.Fragment>
                    );
                })}
            </div>

           
            {modalShow && selectedEvent && (
                <div style={styles.overlay} onClick={closeModal}>
                    <div
                        style={{
                            ...styles.modalBox,
                            maxWidth: modalType === "detail" ? "480px" : "900px",
                            maxHeight: "90vh",
                        }}
                        onClick={e => e.stopPropagation()}
                    >
                        {/* Header */}
                        {/*<div style={styles.header(modalType)}>*/}
                        {/*    <h5 className={`${modalType != "refuse" && modalType != "confirm" ? "form-title" : "" }`} style={styles.headerTitle}>*/}
                        {/*        {modalType === "refuse" ? reduxLanguageTranslations ? reduxLanguageTranslations["refuseEvent"] : "Refuser l'événement"*/}
                        {/*            : modalType === "confirm" ? reduxLanguageTranslations ? reduxLanguageTranslations["confirmEvent"] : "Confirmer l'événement"*/}
                        {/*                : reduxLanguageTranslations ? reduxLanguageTranslations["visitDetails"] : "Détails de la visite"}*/}
                        {/*    </h5>*/}
                        {/*    <img src={closeIcon} onClick={closeModal} style={styles.closeBtn} className="cursor-pointer" />*/}
                        {/*    */}{/*<button onClick={closeModal} style={styles.closeBtn}>✕</button>*/}
                        {/*</div>*/}

                        {/* Header */}
                        <div style={styles.header(modalType)}>
                            <div>
                                <h5 style={{ ...styles.headerTitle, color: modalType === "detail" ? "#1a1a2e" : "#fff" }}>
                                    {modalType === "refuse" ? reduxLanguageTranslations ? reduxLanguageTranslations["refuseEvent"] : "Refuser l'événement"
                                        : modalType === "confirm" ? reduxLanguageTranslations ? reduxLanguageTranslations["confirmEvent"] : "Confirmer l'événement"
                                            : reduxLanguageTranslations ? reduxLanguageTranslations["eventDetailModalSubDetailText"] : "Event Details"}
                                </h5>
                                {/* Status badge — only on detail modal */}
                                {modalType === "detail" && (
                                    <span style={detailStyles.statusBadge}>
                                        {reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownStatusOptionConfirmed"] : "Confirmed" || "Confirmed"}
                                    </span>
                                )}
                            </div>
                            <img src={closeIcon} onClick={closeModal} style={{ ...styles.closeBtn, color: modalType === "detail" ? "#1a1a2e" : "#fff" }} className="cursor-pointer" />
                        </div>

                        {/* ── DETAIL BODY ── */}
                        {modalType === "detail" && (
                            <div style={styles.body}>

                                {/* Property row */}
                                <div style={detailStyles.row}>
                                    <div style={detailStyles.iconCol}>
                                        <div style={detailStyles.iconBox}>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.8">
                                                <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/>
                                                <path d="M9 21V12h6v9"/>
                                            </svg>
                                        </div>
                                        <span style={detailStyles.iconLabel}>{reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalPropertyLabel"] : "Property"}</span>
                                    </div>
                                    <div style={detailStyles.infoCol}>
                                        <span style={detailStyles.infoMain}>
                                            {reduxLanguageTranslations ? reduxLanguageTranslations["topHeaderIDLabel"] : "ID"} {selectedEvent.estateId || "—"}
                                        </span>
                                        <span style={detailStyles.infoSub}>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2" style={{marginRight:4}}>
                                                <circle cx="12" cy="11" r="3"/><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                                            </svg>
                                            {estateData ? `${estateData.address}, ${estateData.number} ${estateData.zip} ${estateData.city}` : "—"}
                                        </span>
                                    </div>
                                </div>

                                <div style={detailStyles.divider} />

                                {/* Agent row */}
                                <div style={detailStyles.row}>
                                    <div style={detailStyles.iconCol}>
                                        <div style={detailStyles.iconBox}>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.8">
                                                <circle cx="12" cy="8" r="4"/>
                                                <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
                                            </svg>
                                        </div>
                                        <span style={detailStyles.iconLabel}>{reduxLanguageTranslations ? reduxLanguageTranslations["confirmSlotModalAgentText"] : "Agent"}</span>
                                    </div>
                                    <div style={detailStyles.infoCol}>
                                        <span style={detailStyles.infoMain}>
                                            {selectedEvent.agentName || "—"}
                                        </span>
                                        <span style={detailStyles.infoSub}>
                                            ID: {selectedEvent.agentId || "—"}
                                        </span>
                                    </div>
                                </div>

                                <div style={detailStyles.divider} />

                                {/* Time row */}
                                <div style={detailStyles.row}>
                                    <div style={detailStyles.iconCol}>
                                        <div style={detailStyles.iconBox}>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.8">
                                                <circle cx="12" cy="12" r="9"/>
                                                <path d="M12 7v5l3 3"/>
                                            </svg>
                                        </div>
                                        <span style={detailStyles.iconLabel}>{reduxLanguageTranslations ? reduxLanguageTranslations["eventEditAndDeleteModalTimeLabel"] : "Time"}</span>
                                    </div>
                                    <div style={detailStyles.infoCol}> 
                                        <span style={detailStyles.infoMain}>
                                            {selectedEvent.eventDateTime || "—"}, {selectedEvent.eventDurationTime || "—"}
                                        </span>
                                    </div>
                                </div>

                                <div style={detailStyles.divider} />

                                {/* Contact row */}
                                <div style={detailStyles.row}>
                                    <div style={detailStyles.iconCol}>
                                        <div style={detailStyles.iconBox}>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.8">
                                                <circle cx="12" cy="8" r="4"/>
                                                <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
                                                <circle cx="12" cy="12" r="10"/>
                                            </svg>
                                        </div>
                                        <span style={detailStyles.iconLabel}>{reduxLanguageTranslations ? reduxLanguageTranslations["eventEditAndDeleteModalContactLabel"] : "Contact"}</span>
                                    </div>
                                    <div style={detailStyles.infoCol}>
                                        <span style={detailStyles.infoMain}>
                                            {selectedEvent.contactFirstName || "—"}
                                        </span>
                                        <span style={detailStyles.infoSub}>
                                            ID: {selectedEvent.contactId || "—"}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        )}

                        {/* ── IFRAME BODY (confirm / refuse) ── */}
                        {(modalType === "confirm" || modalType === "refuse") && (
                            <div style={styles.body}>
                                <div style={styles.iframeWrapper}>
                                    {iframeLoading && (
                                        <div style={styles.iframeLoader}>
                                            <div style={styles.spinner} />
                                            <p style={{ marginTop: 12, color: "#555", fontSize: 13 }}>
                                                {modalType === "refuse" ? "Chargement…" : "Chargement du formulaire…"}
                                            </p>
                                        </div>
                                    )}
                                    <iframe
                                        src={modalType === "refuse"
                                            ? buildRefuseUrl(selectedEvent, reduxSelectedLanguage)
                                            : buildConfirmUrl(selectedEvent, reduxSelectedLanguage)}
                                        title={modalType === "refuse" ? "Refuse Event" : "Confirm Event"}
                                        style={{ ...styles.iframe, opacity: iframeLoading ? 0 : 1 }}
                                        onLoad={() => setIframeLoading(false)}
                                        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
                                    />
                                </div>
                            </div>
                        )}

                        {/* Footer */}
                        {/*<div style={styles.footer}>*/}
                        {/*    <button onClick={closeModal} style={styles.cancelBtn}>*/}
                        {/*        {modalType === "detail" ? reduxLanguageTranslations ? reduxLanguageTranslations["close"] : "Fermer" : reduxLanguageTranslations ? reduxLanguageTranslations["startDatePickerCancelButton"] : "Annuler"}*/}
                        {/*    </button>*/}
                        {/*</div>*/}
                        {/* Footer */}
                        <div style={modalType === "detail" ? detailStyles.footer : styles.footer}>
                            {modalType === "detail" ? (
                                <button onClick={closeModal} style={detailStyles.deleteBtn}>
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["selectionSummaryModalDeleteBtn"] : "Delete"}
                                </button>
                            ) : (
                                <button onClick={closeModal} style={styles.cancelBtn}>
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["startDatePickerCancelButton"] : "Annuler"}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const styles = {
    overlay: {
        position: "fixed", inset: 0,
        backgroundColor: "rgba(0,0,0,0.55)",
        display: "flex", alignItems: "center", justifyContent: "center",
        zIndex: 1050, padding: "16px",
    },
    modalBox: {
        backgroundColor: "#fff", borderRadius: "12px", width: "100%",
        boxShadow: "0 20px 60px rgba(0,0,0,0.28)",
        overflow: "hidden", display: "flex", flexDirection: "column",
    },
    //header: (type) => ({
    //    display: "flex", justifyContent: "space-between", alignItems: "center",
    //    padding: "14px 20px", flexShrink: 0,
    //    backgroundColor: type === "refuse" ? "#C0392B" : type === "detail" ? "" : "#1e7e34",
    //}),
    header: (type) => ({
        display: "flex", justifyContent: "space-between", alignItems: "center",
        padding: "14px 20px", flexShrink: 0,
        backgroundColor: type === "refuse" ? "#C0392B" : type === "detail" ? "#fff" : "#1e7e34",
        borderBottom: type === "detail" ? "1px solid #f0f0f0" : "none",
    }),
    headerTitle: { margin: 0, color: "#fff", fontWeight: 700, fontSize: "15px" },
    closeBtn: {
        background: "transparent", border: "none",
        color: "#fff", fontSize: "18px", cursor: "pointer", lineHeight: 1,
    },
    body: { padding: "20px 24px 8px", overflowY: "auto", flex: 1 },
    iframeWrapper: {
        position: "relative", width: "100%", height: "65vh",
        borderRadius: "8px", overflow: "hidden", border: "1px solid #e0e0e0",
    },
    iframe: {
        width: "100%", height: "100%", border: "none",
        display: "block", transition: "opacity 0.3s ease",
    },
    iframeLoader: {
        position: "absolute", inset: 0,
        display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        backgroundColor: "#f9f9f9", zIndex: 2,
    },
    spinner: {
        width: "36px", height: "36px",
        border: "4px solid #e0e0e0", borderTop: "4px solid #1e7e34",
        borderRadius: "50%", animation: "spin 0.8s linear infinite",
    },
    footer: {
        display: "flex", justifyContent: "flex-end", gap: "10px",
        padding: "14px 24px", borderTop: "1px solid #f0f0f0", flexShrink: 0,
    },
    cancelBtn: {
        padding: "8px 20px", borderRadius: "6px",
        border: "1px solid #ddd", background: "#fff",
        cursor: "pointer", fontSize: "13px", fontWeight: 600, color: "#555",
    },
};

// ─── Detail modal row styles ─────────────────────────────────────────────────
const detailStyles = {
    row: {
        display: "flex",
        alignItems: "center",
        padding: "14px 0",
        gap: "16px",
    },
    iconCol: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "4px",
        minWidth: "52px",
    },
    iconBox: {
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        //background: "#f4f5f7",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },
    iconLabel: {
        fontSize: "11px",
        color: "#6c757d",
        fontWeight: 500,
    },
    infoCol: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: "2px",
    },
    infoMain: {
        fontSize: "13px",
        fontWeight: 600,
        color: "#1a1a2e",
        textAlign: "right",
    },
    infoSub: {
        fontSize: "11px",
        color: "#6c757d",
        textAlign: "right",
        display: "flex",
        alignItems: "center",
    },
    divider: {
        height: "1px",
        background: "#f0f2f5",
        margin: "0 0",
    },
    // ── add these inside detailStyles ──────────────────────────
    statusBadge: {
        display: "inline-block",
        backgroundColor: "rgb(21, 195, 28)", //"#16A34A",
        color: "#fff",
        fontSize: "12px",
        fontWeight: 600,
        padding: "4px 10px",
        borderRadius: "20px",
        marginTop: "6px",
    },
    footer: {
        padding: "16px 20px",
        borderTop: "1px solid #f0f0f0",
        flexShrink: 0,
    },
    deleteBtn: {
        width: "100%",
        padding: "13px",
        borderRadius: "8px",
        border: "1.5px solid #DC2626",
        background: "#fff",
        color: "#DC2626",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: 600,
    },
};

/*
  Add to your global CSS (App.css / index.css):
  @keyframes spin { to { transform: rotate(360deg); } }
*/
